export class CatalogoServicios {

    public id:number;
    public codigoConsorcio:string;
    public codigoServicio:string;
    public descripcionServicio:string;
    public costoEstandar:number;
    public codigoMoneda:string;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/catalogo-servicios.ts